import classNames from "classnames";
import { useEffect } from "react";

const QuantitySelector = ({ value, onChange = () => {}, min = -Infinity, max = Infinity, disabled = false, ...props }) => {
    const handleChangeQuantity = (operation = (value) => {}) => {
        if (!disabled) {
            if (operation(value) > max) {
                onChange && onChange(max);
                return;
            }

            if (operation(value) < min) {
                onChange && onChange(min);
                return;
            }

            onChange && onChange(operation(value));
        }
    }

    useEffect(() => {
        if (!disabled) {
            if (value > max) {
                onChange && onChange(max);
                return;
            }

            if (value < min) {
                onChange && onChange(min);
                return;
            }
        }
    }, [min, max, value])

    return (
        <div style={{ ...props.style }} className={classNames(props.className, "flex items-center w-full")} {...props}>
            <button type="button" style={{ width: props.style?.height || 'auto' }} className={classNames("font-bold flex justify-center items-center h-full text-white text-lg", {
                'bg-primary': !disabled,
                'bg-gray-400 pointer-events-none': disabled
            })} onClick={() => handleChangeQuantity((value) => value - 1)}>{'-'}</button>
            <div className="flex justify-center items-center bg-white border-t border-b w-full h-full">{value}</div>
            <button type="button" style={{ width: props.style?.height || 'auto' }} className={classNames("font-bold flex justify-center items-center h-full text-white text-lg", {
                'bg-primary': !disabled,
                'bg-gray-400 pointer-events-none': disabled
            })} onClick={() => handleChangeQuantity((value) => value + 1)}>{'+'}</button>
        </div>
    )
}

export default QuantitySelector;